import { usePage } from '@inertiajs/vue3'

const getConstantValue = (name) => usePage().props._constants[name]

export const useStatuses = () => getConstantValue('statuses')

export const useAllStatuses = () => getConstantValue('allStatuses')

export const useFieldTypes = (model) => {
  let disabledList = ['uuid', 'json', 'datetime']

  // Datetime is disabled on non-event levels because of concerns mentioned in CORE-9343

  if (model === 'event') {
    disabledList = disabledList.filter((type) => type !== 'datetime')
  }

  return getConstantValue('fieldTypes').filter(
    (field) => !disabledList.includes(field.value),
  )
}

export const useRegistrationTypes = () => getConstantValue('registrationTypes')

export const useCheckoutModes = () => getConstantValue('checkoutModes')

export const useEventCategories = () => getConstantValue('eventCategories')

export const useExtendedFieldModelTypes = () => getConstantValue('modelTypes')

export const useSexes = () => getConstantValue('sexes')

export const useEventEmailRecipients = () =>
  getConstantValue('eventEmailRecipients')

export const useEventChecklistItems = () =>
  getConstantValue('eventChecklistItems')

export const useStripePrices = () => getConstantValue('stripePrices')
export const useStripeSubscriptionPlans = () => useStripePrices().subscriptions
export const useStripeGuestAddOns = () => useStripePrices().addOns.guest
export const useStripeEventSubscriptionsPlans = () =>
  useStripePrices().eventSubscriptions
export const deactivationReasons = () => getConstantValue('deactivatingReason')

export const useAvailabilityTypes = () => getConstantValue('availabilityTypes')

export const usePaymentOrderStatuses = () =>
  getConstantValue('paymentOrderStatuses')
export const usePaymentOrderTypes = () => getConstantValue('paymentOrderTypes')
